import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

import './navbar.css';
import poneyLogo from '../logo/honeypony.png';

const Navbar = () => {
    const [isRotating, setIsRotating] = useState(false);
    const [isScaled, setIsScaled] = useState(false);

    const handleLogoClick = () => {
        setIsRotating(true);
        setTimeout(() => setIsRotating(false), 2000);
    };

    const handleTitleHover = () => {
        setIsScaled(true);
    };

    const handleTitleLeave = () => {
        setIsScaled(false);
    };
    
    const navLink = [
        { path: '/dashboard', label: 'Dashboard' },
        { path: '/datasets', label: 'Datasets' },
        { path: '/publications', label: 'Publications' },
        { path: '/about', label: 'About' },
        { path: '/team', label: 'Team' }
    ];

    return (
        <header>
            <div className='navbar'>

                <div className="logo-container">
                    <h3 className={`logo ${isScaled ? 'logo-scale' : ''}`} onClick={handleLogoClick}>
                        <NavLink
                            exact
                            to="/"
                            style={{ color: '#fff' }}
                            onMouseEnter={handleTitleHover}
                            onMouseLeave={handleTitleLeave}
                        >
                            <span style={{ color: '#FFBF00' }}>Poney</span>
                            Pot
                            <span style={{ color: '#FFBF00' }}>\</span>
                            '
                            <span style={{ color: '#FFBF00' }}>)</span>
                            ;
                            <img src={poneyLogo} alt="PONEYPOT" className={isRotating ? 'rotating' : ''} />
                        </NavLink>
                    </h3>
                </div>

                <div className="navbar-links">
                    <ul>
                        {navLink.map(link => (
                            <li key={link.path}>
                                <NavLink
                                    exact
                                    to={link.path}
                                    className="nav-link"
                                    activeClassName="active-link"
                                >
                                    {link.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </header>
    );
};

export default Navbar;
